import { getModule } from 'vuex-module-decorators'
import { Component, Vue } from 'vue-property-decorator'
import { User } from '@/types/_'
import { getUser } from '@/utils/common'
import ListTable from './list-table/list-table.vue'
import BackofficeChatStore from '../store/backoffice-chat-store'

@Component({
  components: {
    ListTable,
  },
})
export default class ComponentList extends Vue {
  public user: User = { ...getUser() }

  tabChange(tab: 'agendamento' | 'autorizacao' | 'orcamento') {
    this.backofficeChatStore.setActiveTab(tab)
    this.backofficeChatStore.resetPaginator()
    this.backofficeChatStore.loadChats()

    this.ga('backoffice-chat', `visualizar-chat-${tab}`)
  }

  get activeTab() {
    return this.backofficeChatStore.activeTab
  }

  get viewAuthorization() {
    const { roles } = this.user.profile
    if (!roles) return false
    return (roles.length > 0 && roles.includes('backoffice-chat-agendamento'))
      || (roles.length > 0 && roles.includes('backoffice-chat-autorizacao'))
      || (roles.length > 0 && roles.includes('backoffice-chat-orcamento'))
  }

  get backofficeChatStore() {
    return getModule(BackofficeChatStore, this.$store)
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.user.profile.email)
  }
}
